module.exports = __webpack_public_path__ + "static/restaurant_raqou01-a95e19dc152ad476e3fd71336c49ac0e.jpg";